import React from 'react';
const AccessDeniedMessage = ({ type = 'page' }) => {
  return <p>This {type} is available only for logged in users</p>
}
export default AccessDeniedMessage;